import {
  PAPERWORK_ROUTES,
  IPostCreatePaperworkTemplateRequest,
  IPostCreatePaperworkTemplateResponse,
} from "@zeal/common";
import { IAxiosInstance } from "../../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../../AbstractApiClient/IApiResponse";

export const HUNDRED_MEGABYTES = 100 * 1024 * 1024;

export const putPaperworkTemplate = (axios: IAxiosInstance) => {
  return async (data: IPostCreatePaperworkTemplateRequest | FormData) => {
    const response = await axios.noRetry.put<
      IApiResponse<IPostCreatePaperworkTemplateResponse>
    >(PAPERWORK_ROUTES.CREATE_PAPERWORK_TEMPLATE, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 120000, // 2 mins, to support large files (40MB max limit)
      maxBodyLength: HUNDRED_MEGABYTES,
      maxContentLength: HUNDRED_MEGABYTES,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
